module.exports = __webpack_public_path__ + "static/media/seating-white.d24efbfa.svg";